import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
//
import enLocales from './en.json';
import nlLocales from './nl.json';
import deLocales from './de.json';
// ----------------------------------------------------------------------

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'en-US': { translations: enLocales },
      'nl-NL': { translations: nlLocales },
      'de-DE': { translations: deLocales }
    },
    lng: 'nl-NL',
    fallbackLng: 'en-US',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
